<template>
  <div>

    <template v-for="sctn in sections">
      <p><strong>{{sctn.section_name}}</strong></p>
      <Divider class="divider-line"></Divider>
      <Row :gutter="10" style="margin: 15px 0 24px 0">
        <Col span="8" v-for="(item, idx) in sctn.section_items" :key="idx">
          <Card style="padding: 30px 10px" class="cardStyle" :style="idx>2?'margin-top:8px':''">
            <div @click="openListDialog(item.title)" style="display: flex;">
              <div style="margin-right: 10px; margin-top: auto; margin-bottom: auto;">
                <i :class="item.icon" style="font-size: 32px"></i>
              </div>
              <div>
                <span class="card-title" >{{item.title}}</span>
                <p class="card-description">{{item.description}}</p>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </template>
    <!--<city></city>-->
    <!--<area-cmp></area-cmp>-->
    <!--<area-group></area-group>-->
    <manage-territory></manage-territory>
    <user></user>
    <driver></driver>
    <tempo></tempo>
    <truck></truck>
    <contractor></contractor>
  </div>
</template>

<script>
  // import City from './City'
  // import Area from './Area'
  // import AreaGroup from './AreaGroup'
  import ManageTerritory from './ManageTerritory'
  import Driver from './Driver'
  import Tempo from './Tempo'
  import Truck from './Truck'
  import Contractor from './Contractor'
  import User from './User'
  export default {
    name: "Settings",
    // components: {City, 'area-cmp': Area, AreaGroup, Driver, Tempo, Truck, Contractor},
    components: {ManageTerritory, Driver, Tempo, Truck, Contractor, User},
    data: function(){
      return{
        sections: [
          {
            section_name: 'Territory',
            section_items: [
              {
                title: 'MANAGE TERRITORY',
                description: 'Manage Territories',
                icon: 'fal fa-map-marker-alt'
              },
              // {
              //     title: 'CITY',
              //     description: 'Manage cities for Address'
              // },
              // {
              //     title: 'AREA',
              //     description: 'Manage areas for Address'
              // },
              // {
              //     title: 'AREA GROUP',
              //     description: 'Manage area-groups for Areas'
              // }
            ]
          },
          {
             section_name: 'Users & Roles',
             section_items: [
                {
                    title: 'USERS',
                    description: 'Manage Users',
                    icon: 'fas fa-users'
                },
             ]
          },
          {
            section_name: 'Vehicle & Driver',
            section_items: [
              {
                title: 'DRIVER',
                description: 'Manage drivers for Vehicle assignment',
                icon: 'fal fa-steering-wheel'
              },
              {
                title: 'TEMPO',
                description: 'Set tempos for Vehicles',
                icon: 'fal fa-truck-pickup'
              },
              {
                title: 'TRUCK',
                description: 'Set truck for Vehicles',
                icon: 'fal fa-truck'
              },
              {
                title: 'CONTRACTOR',
                description: 'Set contractor for Tempos',
                icon: 'fal fa-file-contract'
              }
            ]
          }
        ],
        manageterritoryListDialog: false,
        // cityListDialog: false,
        // areaListDialog: false,
        // areagroupListDialog: false,
        driverListDialog: false,
        tempoListDialog: false,
        truckListDialog: false,
        contractorListDialog: false,
        usersListDialog: false,
      }
    },
    methods: {
      openListDialog: function(settingMenu){
        settingMenu = settingMenu.replace(/ /g,'');
        let dialogName = settingMenu.toLowerCase() + 'ListDialog'
        this[dialogName] = true;
      }
    }

  }
</script>

<style scoped>
  /deep/ .ivu-card-body{
    padding: 0px;
  }
  /deep/ .ivu-card-body > div{
    padding: 16px;
  }
  /deep/ .divider-line{
    height: 2px !important;
    margin: 5px 0 !important;
  }
  .card-title{
    font-size: 18px;

  }
  .card-description{
    font-size: 14px;
    color: #596363;
    font-weight: 300;

  }
  .cardStyle{
    background: #fff !important;
    border-radius: 10px;
    box-shadow: 0px 2px 5px -3px;
    position: relative;
    cursor: pointer;
  }
  .cardStyle:hover{
    box-shadow: 0px 2px 7px -2px !important;
  }
</style>
